import { faker } from '@faker-js/faker';

import type { MarketingPreferencesGetResponse } from '../types/MarketingPreferencesGetResponse';

export function createMarketingPreferencesGetResponse(
  data: NonNullable<Partial<MarketingPreferencesGetResponse>> = {}
): NonNullable<MarketingPreferencesGetResponse> {
  return {
    ...{
      data: { value: faker.string.alpha() },
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
